import glamorous from "glamorous";
import { css } from "glamor";

export const Spinner = glamorous.div({
  width: 20,
  height: 20,
  clear: "both",
  margin: "20px auto",
  border: `4px rgba(251,183,49, 0.25) solid`,
  borderTop: `4px rgba(251,183,49, 1) solid`,
  borderRadius: "50%",
  animation: `${css.keyframes({
    "0%": {
      transform: "rotate(0deg)"
    },
    "100%": {
      transform: "rotate(359deg)"
    }
  })} 1s infinite linear`
});



// WEBPACK FOOTER //
// ./src/components/loading/styles.js